import {Link, NavLink, useLocation} from 'react-router-dom';
import React from 'react';

const PAGES_ROUTES = ['/history', '/team', '/gallery', '/blog', '/recruitment'];

const MainMenu = ({type, isSticky}) => {
    const topItemStyle = !isSticky && type === 1 ? {color: 'var(--brand-navy)'} : undefined;
    const {pathname} = useLocation();
    const isPagesActive = PAGES_ROUTES.some((route) => pathname.startsWith(route));

    const linkClass = ({isActive}) => (isActive ? 'active' : '');

    return (
        <>
            <ul>
                <li><NavLink to='/' end className={linkClass} style={topItemStyle}>Home</NavLink></li>
                <li><NavLink to='/about-us' className={linkClass} style={topItemStyle}>About Us</NavLink></li>
                <li><NavLink to='/services' className={linkClass} style={topItemStyle}>Services</NavLink></li>
                <li><NavLink to='/portfolio' className={linkClass} style={topItemStyle}>Portfolio</NavLink></li>
                <li className='menu-item-has-children'>
                    <Link className={isPagesActive ? 'active' : ''} style={topItemStyle}>Pages</Link>
                    <ul className={!isSticky && type === 1 ? "sub-menu-light" : "sub-menu"}>
                        <li><Link to='/history'>Company History</Link></li>
                        <li><Link to='/team'>Company Organizational Structure</Link></li>
                        <li><Link to='/gallery'>Gallery</Link></li>
                        <li><Link to='/blog'>Blog and News</Link></li>
                        <li><Link to='/recruitment'>Recruitments</Link></li>
                    </ul>
                </li>
                <li><NavLink to='/contact-us' className={linkClass} style={topItemStyle}>Contact Us</NavLink></li>
            </ul>
        </>
    );
};

export default MainMenu;